import * as Types from './types';

import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

export const CreateFormSubmissionDocument = gql`
    mutation CreateFormSubmission($payload: CreateFormSubmissionInput!) {
  createFormSubmission(payload: $payload) {
    _id
    template {
      _id
      title
      description
      fields {
        id
        type
        label
        required
        options
      }
    }
    responses {
      fieldId
      value
    }
    status
    submittedAt
    submittedBy {
      userInfo {
        name
        surname
      }
    }
    tags
    createdAt
    updatedAt
  }
}
    `;
export const CreateOrderDocument = gql`
    mutation createOrder($payload: CreateOrderInput!) {
  createOrder(payload: $payload) {
    _id
    referenceId
    consultation {
      _id
    }
  }
}
    `;
export const CreatePaymentSessionDocument = gql`
    mutation CreatePaymentSession($payload: CreatePaymentSessionInput!) {
  createPaymentSession(payload: $payload) {
    sessionId
  }
}
    `;
export const DeleteFilesDocument = gql`
    mutation deleteFiles($payload: DeleteFilesInput!) {
  deleteFiles(payload: $payload)
}
    `;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($orderId: String!) {
  deleteOrder(orderId: $orderId)
}
    `;
export const GeneratePresignedUrlDocument = gql`
    mutation GeneratePresignedUrl($payload: CreatePresignedUrlInput!) {
  generatePresignedUrl(payload: $payload)
}
    `;
export const AddSavedAddressDocument = gql`
    mutation addSavedAddress($payload: SavedAddressInput!) {
  addSavedAddress(payload: $payload) {
    _id
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
  }
}
    `;
export const UpdateSavedAddressDocument = gql`
    mutation updateSavedAddress($payload: UpdateSavedAddressInput!) {
  updateSavedAddress(payload: $payload) {
    _id
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
  }
}
    `;
export const DeleteSavedAddressDocument = gql`
    mutation deleteSavedAddress($addressId: String!) {
  deleteSavedAddress(addressId: $addressId) {
    _id
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
  }
}
    `;
export const SendExpertiseMessageDocument = gql`
    mutation SendExpertiseMessage($payload: SendExpertiseMessageInput!) {
  sendExpertiseMessage(payload: $payload) {
    _id
    messages {
      content
      author {
        _id
        userInfo {
          name
          surname
        }
      }
      date
      readBy {
        _id
      }
    }
  }
}
    `;
export const SignUpDocument = gql`
    mutation SignUp($payload: SignUpInput!) {
  signUp(payload: $payload)
}
    `;
export const UpdateConsultationStatusDocument = gql`
    mutation updateConsultationStatus($payload: UpdateConsultationStatus!) {
  updateConsultationStatus(payload: $payload) {
    _id
    status
  }
}
    `;
export const UpdateMyInfosDocument = gql`
    mutation updateMyInfos($payload: UpdatePatientInput!) {
  updateMyInfos(payload: $payload) {
    _id
    userInfo {
      name
      surname
      language
    }
  }
}
    `;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($orderId: String!, $input: CreateOrderInput!) {
  updateOrder(orderId: $orderId, input: $input) {
    _id
    status
    comment
    files {
      filename
      key
      objectType
      uploadedBy
      url
    }
    referenceId
    startDate
    speciality
    meetingPlace {
      description
      placeId
    }
  }
}
    `;
export const UpdateOrderStatusDocument = gql`
    mutation updateOrderStatus($payload: UpdateOrderStatus!) {
  updateOrderStatus(payload: $payload) {
    _id
    status
    formSubmission {
      _id
      template {
        _id
        title
        description
        fields {
          id
          type
          label
          required
          options
        }
      }
      responses {
        fieldId
        value
      }
      status
      submittedAt
      submittedBy {
        userInfo {
          name
          surname
        }
      }
      tags
      createdAt
      updatedAt
    }
  }
}
    `;
export const UpdatePatientDataReuseConsentDocument = gql`
    mutation updatePatientDataReuseConsent($payload: UpdatePatientDataReuseConsentInput!) {
  updatePatientDataReuseConsent(payload: $payload) {
    _id
    patientConsent {
      recordingConsent
      dataReuseConsent
    }
  }
}
    `;
export const UpdatePatientLocationDocument = gql`
    mutation updatePatientLocation($payload: UpdatePatientLocationInput!) {
  updatePatientLocation(payload: $payload) {
    _id
    patientLocation {
      description
      placeId
    }
  }
}
    `;
export const UploadFileDocument = gql`
    mutation UploadFile($payload: UploadFileInput!) {
  uploadFile(payload: $payload) {
    _id
    files {
      filename
      key
      objectType
      url
    }
  }
}
    `;
export const GetChimeMeetingDocument = gql`
    query getChimeMeeting($meetingType: String!, $roomOrConsultationId: String!, $userId: String!) {
  chimeMeeting(
    meetingType: $meetingType
    roomOrConsultationId: $roomOrConsultationId
    userId: $userId
  ) {
    attendeeInfo {
      AttendeeId
      ExternalUserId
      JoinToken
    }
    meetingInfo {
      MeetingId
      MediaPlacement {
        AudioHostUrl
        AudioFallbackUrl
        ScreenDataUrl
        ScreenSharingUrl
        ScreenViewingUrl
        SignalingUrl
        TurnControlUrl
        EventIngestionUrl
      }
    }
  }
}
    `;
export const GetConsultationDocument = gql`
    query getConsultation($id: String!) {
  consultation(id: $id) {
    _id
    status
    startDate
    speciality
    medecin {
      _id
      userInfo {
        name
        surname
      }
    }
    waitingRoom
  }
}
    `;
export const GetEstablishmentDocument = gql`
    query getEstablishment($slug: String!) {
  establishment(slug: $slug) {
    name
    meetingLinks {
      _id
      name
      slug
      specialities {
        code
        name
      }
    }
  }
}
    `;
export const GetFormTemplateDocument = gql`
    query GetFormTemplate($id: String!) {
  formTemplate(id: $id) {
    _id
    title
    description
    version
    categories
    tags
    fields {
      id
      type
      label
      required
      options
    }
    isActive
    createdAt
    updatedAt
  }
}
    `;
export const GetActiveFormTemplatesDocument = gql`
    query GetActiveFormTemplates {
  activeFormTemplates {
    _id
    title
    description
    version
    categories
    tags
    fields {
      id
      type
      label
      required
      options
    }
    isActive
    createdAt
    updatedAt
  }
}
    `;
export const GetFormSubmissionDocument = gql`
    query GetFormSubmission($id: String!) {
  formSubmission(id: $id) {
    _id
    template {
      _id
      title
      description
      fields {
        id
        type
        label
        required
        options
      }
    }
    responses {
      fieldId
      value
    }
    status
    submittedAt
    submittedBy {
      userInfo {
        name
        surname
      }
    }
    tags
    createdAt
    updatedAt
  }
}
    `;
export const GetPatientWaitingStatusDocument = gql`
    query getPatientWaitingStatus($consultationId: String!) {
  getPatientWaitingStatus(consultationId: $consultationId) {
    consultationId
    doctorStatus
    canJoin
  }
}
    `;
export const GetPaymentStatusDocument = gql`
    query GetPaymentStatus($payload: GetPaymentStatusInput!) {
  getPaymentStatus(payload: $payload) {
    paid
    sessionId
    receiptUrl
  }
}
    `;
export const GetMeetingLinkDocument = gql`
    query getMeetingLink($slug: String!) {
  meetingLink(slug: $slug) {
    _id
    availabilities {
      _id
      address {
        description
        placeId
      }
      additionalAddress
      avgMeetingDuration
      isRecurrence
      meetingPlace
      notes
      formTemplate {
        _id
        title
        description
        fields {
          id
          type
          label
          required
          options
        }
        isActive
      }
      recurrenceDays {
        day
        periods {
          open
          close
        }
        timeZone
      }
      scheduledDays {
        day
        format
        periods {
          open
          close
        }
        timeZone
      }
      specialities
      unavailabilities {
        _id
        startDate
        endDate
        startTime
        endTime
      }
      paymentConfig {
        requiresPayment
        basePrice
        paymentReceiver {
          _id
          userInfo {
            name
            surname
          }
          stripe
          stripeActivated
        }
        priceModifiers {
          meetingPlace
          modifier
        }
      }
      serviceArea {
        allowedPostalCodes
        center {
          description
          placeId
          lat
          lng
        }
        radiusKm
      }
    }
    busySlots {
      start
      end
    }
    createdBy {
      _id
      establishment {
        name
        slug
      }
      userInfo {
        name
        surname
      }
      slug
    }
    description
    name
    specialities {
      code
      name
      price
    }
    staffs {
      _id
      userInfo {
        name
        surname
      }
      status
      stripe
      stripeActivated
    }
    immediateConsultationConfig {
      enabled
      maxWaitingPatients
      requirePaymentUpfront
      price
      paymentReceiver {
        _id
        userInfo {
          name
          surname
        }
        stripe
        stripeActivated
      }
    }
    waitingRoom {
      _id
      name
      avgWaitingTime
    }
  }
}
    `;
export const SearchMeetingLinksDocument = gql`
    query searchMeetingLinks($phrase: String!) {
  meetingLinksSearch(phrase: $phrase) {
    __typename
    ... on Etablissement {
      _id
      name
      slug
    }
    ... on MeetingLink {
      _id
      name
      slug
      specialities {
        code
        name
      }
    }
  }
}
    `;
export const GetMyInfosDocument = gql`
    query getMyInfos {
  myInfos {
    _id
    agreement
    isProfileComplete
    isConsultationReady
    consultations {
      _id
      autoRecording
      recordingConsentPending
      biologicals {
        id
      }
      commentaire
      createdBy {
        userInfo {
          name
          surname
        }
      }
      endDate
      establishment {
        _id
        name
      }
      files {
        filename
        key
        url
      }
      medecin {
        _id
        userInfo {
          gender
          name
          surname
        }
        civility
        title
        speciality
        teleconsultationTraining {
          type
          description
        }
        cabinetAddresses {
          description
        }
      }
      pds {
        _id
        userInfo {
          name
          surname
          gender
        }
      }
      mesures {
        label
        order
        unit
        value
      }
      paid
      patientConsent {
        recordingConsent
      }
      patientLocation {
        description
        placeId
      }
      startDate
      status
      type
      waitingRoom
    }
    email
    establishment {
      _id
      name
    }
    files {
      filename
      key
      url
    }
    userInfo {
      birthday
      gender
      name
      surname
      language
      birthName
      birthFirstName
      birthSurname
      birthPlace
      birthPlaceCode
    }
    orders {
      _id
      acceptedBy {
        userInfo {
          gender
          name
          surname
        }
      }
      speciality
      referenceId
      startDate
      status
      meetingPlace {
        description
        placeId
        apartment
        floor
        doorCode
        instructions
        postalCode
      }
      meetingLink {
        _id
        description
        isPrioritized
        name
        specialities {
          name
          price
        }
        staffs {
          userInfo {
            name
          }
        }
      }
      files {
        url
        key
        filename
      }
      formSubmission {
        _id
        template {
          _id
          title
          description
          fields {
            id
            type
            label
            required
            options
          }
        }
        responses {
          fieldId
          value
        }
        status
        submittedAt
        submittedBy {
          userInfo {
            name
            surname
          }
        }
        tags
        createdAt
        updatedAt
      }
    }
    secu
    insNIR
    insOID
    contactInfo {
      phone
      cp
      city
      street
      country
    }
    savedAddresses {
      _id
      label
      street
      city
      postalCode
      country
      apartment
      floor
      doorCode
      instructions
      placeId
      coordinates {
        lat
        lng
      }
      isDefault
    }
    attendingPhysician {
      firstname
      lastname
      gender
      email
      phone
    }
    parents {
      _id
      city
      cp
      email
      firstname
      lastname
      phone
      street
    }
    insured
    insuredRelationship
    insuranceProvider
    primaryInsurance
    secondaryInsurance
    primaryPolicy
    secondaryPolicy
    primaryPharmacy
    events {
      _id
      createdAt
      object_id
      object_type
      channels
      type
      recipients {
        userId
        type
        read
      }
    }
    expertises {
      _id
      status
      startDate
      endDate
      speciality
      conclusion
      diagnostic
      comment
      consultations {
        _id
        startDate
        status
        speciality
      }
      files {
        filename
        key
        objectType
        url
      }
      chatRoom {
        _id
        messages {
          content
          author {
            _id
            userInfo {
              name
              surname
            }
          }
          readBy {
            _id
          }
          date
        }
      }
      medecin {
        _id
        userInfo {
          name
          surname
        }
        speciality
      }
      createdBy {
        _id
        userInfo {
          name
          surname
        }
        speciality
        status
      }
      patient {
        _id
      }
      formSubmissions {
        _id
        template {
          _id
          title
          description
          version
          fields {
            id
            type
            label
            required
            options
          }
        }
        responses {
          fieldId
          value
        }
        status
        submittedBy {
          userInfo {
            name
            surname
          }
        }
        tags
        submittedAt
        createdAt
        updatedAt
      }
    }
    formSubmissions {
      _id
      template {
        _id
        title
        description
        version
        categories
        tags
        fields {
          id
          type
          label
          required
          options
        }
      }
      patient {
        _id
      }
      consultation {
        _id
        startDate
        status
      }
      expertise {
        _id
        startDate
        status
      }
      responses {
        fieldId
        value
      }
      status
      submittedBy {
        userInfo {
          name
          surname
        }
      }
      ethicsResponse
      respondedBy {
        userInfo {
          name
          surname
        }
      }
      respondedAt
      tags
      submittedAt
      createdAt
      updatedAt
    }
  }
}
    `;
export const GetOrderDocument = gql`
    query getOrder($orderId: String!) {
  meetingLinkOrder(orderId: $orderId) {
    _id
    meetingPlace {
      description
    }
    files {
      filename
      key
      url
    }
    referenceId
    speciality
    startDate
    status
    consultation {
      _id
    }
  }
}
    `;
export const GetPatientFilesDocument = gql`
    query getPatientFiles {
  myInfos {
    _id
    consultations {
      endDate
      files {
        filename
        key
        url
      }
      startDate
      status
      _id
    }
    files {
      filename
      key
      url
    }
  }
}
    `;
export const ListPrioritizedMeetingLinksDocument = gql`
    query listPrioritizedMeetingLinks {
  prioritizedMeetingLinks {
    _id
    availabilities {
      _id
      address {
        description
        placeId
      }
    }
    description
    name
    slug
    specialities {
      code
      name
    }
  }
}
    `;
export const GetTrackedOrderDocument = gql`
    query getTrackedOrder($referenceId: String!) {
  trackedOrder(referenceId: $referenceId) {
    _id
    referenceId
    meetingPlace {
      description
    }
    createdBy {
      email
      contactInfo {
        phone
      }
      userInfo {
        name
        surname
      }
    }
    speciality
    startDate
    status
    consultation {
      _id
    }
    files {
      filename
      key
      url
    }
    meetingLink {
      _id
      name
    }
    acceptedBy {
      userInfo {
        gender
        name
        surname
      }
      speciality
    }
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    CreateFormSubmission(variables: Types.CreateFormSubmissionMutationVariables, options?: C): Promise<Types.CreateFormSubmissionMutation> {
      return requester<Types.CreateFormSubmissionMutation, Types.CreateFormSubmissionMutationVariables>(CreateFormSubmissionDocument, variables, options) as Promise<Types.CreateFormSubmissionMutation>;
    },
    createOrder(variables: Types.CreateOrderMutationVariables, options?: C): Promise<Types.CreateOrderMutation> {
      return requester<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>(CreateOrderDocument, variables, options) as Promise<Types.CreateOrderMutation>;
    },
    CreatePaymentSession(variables: Types.CreatePaymentSessionMutationVariables, options?: C): Promise<Types.CreatePaymentSessionMutation> {
      return requester<Types.CreatePaymentSessionMutation, Types.CreatePaymentSessionMutationVariables>(CreatePaymentSessionDocument, variables, options) as Promise<Types.CreatePaymentSessionMutation>;
    },
    deleteFiles(variables: Types.DeleteFilesMutationVariables, options?: C): Promise<Types.DeleteFilesMutation> {
      return requester<Types.DeleteFilesMutation, Types.DeleteFilesMutationVariables>(DeleteFilesDocument, variables, options) as Promise<Types.DeleteFilesMutation>;
    },
    DeleteOrder(variables: Types.DeleteOrderMutationVariables, options?: C): Promise<Types.DeleteOrderMutation> {
      return requester<Types.DeleteOrderMutation, Types.DeleteOrderMutationVariables>(DeleteOrderDocument, variables, options) as Promise<Types.DeleteOrderMutation>;
    },
    GeneratePresignedUrl(variables: Types.GeneratePresignedUrlMutationVariables, options?: C): Promise<Types.GeneratePresignedUrlMutation> {
      return requester<Types.GeneratePresignedUrlMutation, Types.GeneratePresignedUrlMutationVariables>(GeneratePresignedUrlDocument, variables, options) as Promise<Types.GeneratePresignedUrlMutation>;
    },
    addSavedAddress(variables: Types.AddSavedAddressMutationVariables, options?: C): Promise<Types.AddSavedAddressMutation> {
      return requester<Types.AddSavedAddressMutation, Types.AddSavedAddressMutationVariables>(AddSavedAddressDocument, variables, options) as Promise<Types.AddSavedAddressMutation>;
    },
    updateSavedAddress(variables: Types.UpdateSavedAddressMutationVariables, options?: C): Promise<Types.UpdateSavedAddressMutation> {
      return requester<Types.UpdateSavedAddressMutation, Types.UpdateSavedAddressMutationVariables>(UpdateSavedAddressDocument, variables, options) as Promise<Types.UpdateSavedAddressMutation>;
    },
    deleteSavedAddress(variables: Types.DeleteSavedAddressMutationVariables, options?: C): Promise<Types.DeleteSavedAddressMutation> {
      return requester<Types.DeleteSavedAddressMutation, Types.DeleteSavedAddressMutationVariables>(DeleteSavedAddressDocument, variables, options) as Promise<Types.DeleteSavedAddressMutation>;
    },
    SendExpertiseMessage(variables: Types.SendExpertiseMessageMutationVariables, options?: C): Promise<Types.SendExpertiseMessageMutation> {
      return requester<Types.SendExpertiseMessageMutation, Types.SendExpertiseMessageMutationVariables>(SendExpertiseMessageDocument, variables, options) as Promise<Types.SendExpertiseMessageMutation>;
    },
    SignUp(variables: Types.SignUpMutationVariables, options?: C): Promise<Types.SignUpMutation> {
      return requester<Types.SignUpMutation, Types.SignUpMutationVariables>(SignUpDocument, variables, options) as Promise<Types.SignUpMutation>;
    },
    updateConsultationStatus(variables: Types.UpdateConsultationStatusMutationVariables, options?: C): Promise<Types.UpdateConsultationStatusMutation> {
      return requester<Types.UpdateConsultationStatusMutation, Types.UpdateConsultationStatusMutationVariables>(UpdateConsultationStatusDocument, variables, options) as Promise<Types.UpdateConsultationStatusMutation>;
    },
    updateMyInfos(variables: Types.UpdateMyInfosMutationVariables, options?: C): Promise<Types.UpdateMyInfosMutation> {
      return requester<Types.UpdateMyInfosMutation, Types.UpdateMyInfosMutationVariables>(UpdateMyInfosDocument, variables, options) as Promise<Types.UpdateMyInfosMutation>;
    },
    UpdateOrder(variables: Types.UpdateOrderMutationVariables, options?: C): Promise<Types.UpdateOrderMutation> {
      return requester<Types.UpdateOrderMutation, Types.UpdateOrderMutationVariables>(UpdateOrderDocument, variables, options) as Promise<Types.UpdateOrderMutation>;
    },
    updateOrderStatus(variables: Types.UpdateOrderStatusMutationVariables, options?: C): Promise<Types.UpdateOrderStatusMutation> {
      return requester<Types.UpdateOrderStatusMutation, Types.UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, variables, options) as Promise<Types.UpdateOrderStatusMutation>;
    },
    updatePatientDataReuseConsent(variables: Types.UpdatePatientDataReuseConsentMutationVariables, options?: C): Promise<Types.UpdatePatientDataReuseConsentMutation> {
      return requester<Types.UpdatePatientDataReuseConsentMutation, Types.UpdatePatientDataReuseConsentMutationVariables>(UpdatePatientDataReuseConsentDocument, variables, options) as Promise<Types.UpdatePatientDataReuseConsentMutation>;
    },
    updatePatientLocation(variables: Types.UpdatePatientLocationMutationVariables, options?: C): Promise<Types.UpdatePatientLocationMutation> {
      return requester<Types.UpdatePatientLocationMutation, Types.UpdatePatientLocationMutationVariables>(UpdatePatientLocationDocument, variables, options) as Promise<Types.UpdatePatientLocationMutation>;
    },
    UploadFile(variables: Types.UploadFileMutationVariables, options?: C): Promise<Types.UploadFileMutation> {
      return requester<Types.UploadFileMutation, Types.UploadFileMutationVariables>(UploadFileDocument, variables, options) as Promise<Types.UploadFileMutation>;
    },
    getChimeMeeting(variables: Types.GetChimeMeetingQueryVariables, options?: C): Promise<Types.GetChimeMeetingQuery> {
      return requester<Types.GetChimeMeetingQuery, Types.GetChimeMeetingQueryVariables>(GetChimeMeetingDocument, variables, options) as Promise<Types.GetChimeMeetingQuery>;
    },
    getConsultation(variables: Types.GetConsultationQueryVariables, options?: C): Promise<Types.GetConsultationQuery> {
      return requester<Types.GetConsultationQuery, Types.GetConsultationQueryVariables>(GetConsultationDocument, variables, options) as Promise<Types.GetConsultationQuery>;
    },
    getEstablishment(variables: Types.GetEstablishmentQueryVariables, options?: C): Promise<Types.GetEstablishmentQuery> {
      return requester<Types.GetEstablishmentQuery, Types.GetEstablishmentQueryVariables>(GetEstablishmentDocument, variables, options) as Promise<Types.GetEstablishmentQuery>;
    },
    GetFormTemplate(variables: Types.GetFormTemplateQueryVariables, options?: C): Promise<Types.GetFormTemplateQuery> {
      return requester<Types.GetFormTemplateQuery, Types.GetFormTemplateQueryVariables>(GetFormTemplateDocument, variables, options) as Promise<Types.GetFormTemplateQuery>;
    },
    GetActiveFormTemplates(variables?: Types.GetActiveFormTemplatesQueryVariables, options?: C): Promise<Types.GetActiveFormTemplatesQuery> {
      return requester<Types.GetActiveFormTemplatesQuery, Types.GetActiveFormTemplatesQueryVariables>(GetActiveFormTemplatesDocument, variables, options) as Promise<Types.GetActiveFormTemplatesQuery>;
    },
    GetFormSubmission(variables: Types.GetFormSubmissionQueryVariables, options?: C): Promise<Types.GetFormSubmissionQuery> {
      return requester<Types.GetFormSubmissionQuery, Types.GetFormSubmissionQueryVariables>(GetFormSubmissionDocument, variables, options) as Promise<Types.GetFormSubmissionQuery>;
    },
    getPatientWaitingStatus(variables: Types.GetPatientWaitingStatusQueryVariables, options?: C): Promise<Types.GetPatientWaitingStatusQuery> {
      return requester<Types.GetPatientWaitingStatusQuery, Types.GetPatientWaitingStatusQueryVariables>(GetPatientWaitingStatusDocument, variables, options) as Promise<Types.GetPatientWaitingStatusQuery>;
    },
    GetPaymentStatus(variables: Types.GetPaymentStatusQueryVariables, options?: C): Promise<Types.GetPaymentStatusQuery> {
      return requester<Types.GetPaymentStatusQuery, Types.GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, variables, options) as Promise<Types.GetPaymentStatusQuery>;
    },
    getMeetingLink(variables: Types.GetMeetingLinkQueryVariables, options?: C): Promise<Types.GetMeetingLinkQuery> {
      return requester<Types.GetMeetingLinkQuery, Types.GetMeetingLinkQueryVariables>(GetMeetingLinkDocument, variables, options) as Promise<Types.GetMeetingLinkQuery>;
    },
    searchMeetingLinks(variables: Types.SearchMeetingLinksQueryVariables, options?: C): Promise<Types.SearchMeetingLinksQuery> {
      return requester<Types.SearchMeetingLinksQuery, Types.SearchMeetingLinksQueryVariables>(SearchMeetingLinksDocument, variables, options) as Promise<Types.SearchMeetingLinksQuery>;
    },
    getMyInfos(variables?: Types.GetMyInfosQueryVariables, options?: C): Promise<Types.GetMyInfosQuery> {
      return requester<Types.GetMyInfosQuery, Types.GetMyInfosQueryVariables>(GetMyInfosDocument, variables, options) as Promise<Types.GetMyInfosQuery>;
    },
    getOrder(variables: Types.GetOrderQueryVariables, options?: C): Promise<Types.GetOrderQuery> {
      return requester<Types.GetOrderQuery, Types.GetOrderQueryVariables>(GetOrderDocument, variables, options) as Promise<Types.GetOrderQuery>;
    },
    getPatientFiles(variables?: Types.GetPatientFilesQueryVariables, options?: C): Promise<Types.GetPatientFilesQuery> {
      return requester<Types.GetPatientFilesQuery, Types.GetPatientFilesQueryVariables>(GetPatientFilesDocument, variables, options) as Promise<Types.GetPatientFilesQuery>;
    },
    listPrioritizedMeetingLinks(variables?: Types.ListPrioritizedMeetingLinksQueryVariables, options?: C): Promise<Types.ListPrioritizedMeetingLinksQuery> {
      return requester<Types.ListPrioritizedMeetingLinksQuery, Types.ListPrioritizedMeetingLinksQueryVariables>(ListPrioritizedMeetingLinksDocument, variables, options) as Promise<Types.ListPrioritizedMeetingLinksQuery>;
    },
    getTrackedOrder(variables: Types.GetTrackedOrderQueryVariables, options?: C): Promise<Types.GetTrackedOrderQuery> {
      return requester<Types.GetTrackedOrderQuery, Types.GetTrackedOrderQueryVariables>(GetTrackedOrderDocument, variables, options) as Promise<Types.GetTrackedOrderQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;